import { createSelector } from "reselect";

const readMessageStatusSelector = (state: TReduxState) =>
  state.features.readMessageStatus;

export const getReadMessageStatus = createSelector(
  readMessageStatusSelector,
  (readMessageStatus) => readMessageStatus.readStatus
);
